module.exports = __webpack_public_path__ + "d378c4e908448f844e0c43b6280159c8.png";